export default {
    functional: true,
    render(h, { props, listeners }) {
        return [
            h(
                'router-link', 
                {
                    attrs: { id: `edit-${props.table}-${props.id}`, to: `${props.to}` }
                }, 
                `Edit`
            ),
            !props.disableDelete ? ' - ' : null,
            !props.disableDelete
                ?   h(
                        'b-link', 
                        {
                            attrs: { id: `delete-${props.table}-${props.id}`, href: '#' },
                            on:{ click: () => listeners.click(props.id) }
                        }, 
                        'Delete'
                    )
            :   null
        ]
    }
}
